import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './styles/theme';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/common/ErrorBoundary';

// Layout
import Layout from './components/layout/Layout';

// Pages
import Home from './components/pages/Home';
import About from './components/pages/About';
import Services from './components/pages/Services';
import Contact from './components/pages/Contact';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import Careers from './components/pages/Careers';
import NotFound from './components/common/NotFound';

function App() {
    return (
        <ErrorBoundary>
            <Router>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <AuthProvider>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/services" element={<Services />} />
                                <Route path="/careers" element={<Careers />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/privacy" element={<PrivacyPolicy />} />
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </Layout>
                    </AuthProvider>
                </ThemeProvider>
            </Router>
        </ErrorBoundary>
    );
}

export default App;